import { render, staticRenderFns } from "./HomeFour.vue?vue&type=template&id=29cbe4f4&"
import script from "./HomeFour.vue?vue&type=script&lang=js&"
export * from "./HomeFour.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports